"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _MenuLink = require("./MenuLink");

var _MenuLink2 = _interopRequireDefault(_MenuLink);

var _UserUtil = require("../../utils/UserUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Menu, _Component);

  function Menu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.logout = function (event) {
      event.preventDefault();
      _this.props.logout();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Menu, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          type = _props.type,
          toggle = _props.toggle;

      var classNames = "container menu-container";
      if (this.props.open) {
        classNames += " menu-container-open";
      }

      if (type === "desktop") {
        return this.renderMenuLinks();
      }

      return _react2.default.createElement(
        "div",
        { className: classNames },
        _react2.default.createElement(
          "div",
          { className: "row menu-header" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-8 col-xs-offset-2 menu-header-title" },
            "Valikko"
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-2 menu-header-button" },
            _react2.default.createElement("i", {
              className: "icon-mp-close close-icon-js",
              "aria-hidden": "true",
              onClick: toggle
            })
          )
        ),
        this.renderMenuLinks(toggle)
      );
    }
  }, {
    key: "renderMenuLinks",
    value: function renderMenuLinks(toggleFunc) {
      return _react2.default.createElement(
        "div",
        { className: "menu" },
        this.renderMenuLink("/", "Etusivu", toggleFunc, true),
        _react2.default.createElement(
          "div",
          { className: "menu-group" },
          this.renderMenuLink("/tietoa-palvelusta", "Tietoa palvelusta", toggleFunc),
          _react2.default.createElement(
            "div",
            { className: "menu-sublinks" },
            this.renderSubLink("/hinnasto", "Hinnasto", toggleFunc),
            this.renderSubLink("/yhteystiedot", "Yhteystiedot", toggleFunc),
            this.renderSubLink("/palaute", "Anna palautetta", toggleFunc)
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "menu-group" },
          this.renderMenuLink("/ilmoitukset", "Selaa ilmoituksia", toggleFunc),
          _react2.default.createElement(
            "div",
            { className: "menu-sublinks" },
            this.renderSubLink("/jata-ilmoitus", "Ilmoita ilmaiseksi", toggleFunc),
            this.renderSubLink("/maalajikuvaukset", "Maalajikuvaukset", toggleFunc)
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "menu-group" },
          this.renderMenuLink("/lipukekauppa", "Lipukekauppa", toggleFunc),
          this.props.user && _react2.default.createElement(
            "div",
            { className: "menu-sublinks" },
            this.renderSubLink("/ostetut-vastaanottolipukkeet", "Ostetut lipukkeet", toggleFunc)
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "menu-group" },
          (0, _UserUtil.isPaidUser)(this.props.user) && _react2.default.createElement(
            "div",
            { className: "menu-sublinks" },
            (0, _UserUtil.isPaidUser)(this.props.user) && this.props.company ? this.renderSubLink("/lisenssit", "Lisenssit", toggleFunc) : "",
            (0, _UserUtil.isPaidUser)(this.props.user) && this.props.company ? this.renderSubLink("/projektit", "Projektit", toggleFunc) : "",
            (0, _UserUtil.isPaidUser)(this.props.user) ? this.renderSubLink("/omat-ajot", "Kuljetusraportti", toggleFunc) : ""
          )
        ),
        this.renderMenuLink("/lisapalvelut", "Lisäpalvelut", toggleFunc),
        this.renderCompanyLinks(toggleFunc),
        _react2.default.createElement("div", { className: "menu-divider" }),
        this.renderAuthLinks(toggleFunc)
      );
    }
  }, {
    key: "renderSubLink",
    value: function renderSubLink(link, text, handleClick) {
      var props = { link: link, text: text, handleClick: handleClick };
      return _react2.default.createElement(_MenuLink2.default, (0, _extends3.default)({ small: true }, props));
    }
  }, {
    key: "renderMenuLink",
    value: function renderMenuLink(link, text, handleClick, mobileOnly) {
      var props = { link: link, text: text, handleClick: handleClick, mobileOnly: mobileOnly };
      return _react2.default.createElement(_MenuLink2.default, props);
    }
  }, {
    key: "renderCompanyLinks",
    value: function renderCompanyLinks(toggleFunc) {
      var company = this.props.company;

      if (company && company.users && company.users.length) {
        return _react2.default.createElement(_MenuLink2.default, {
          link: "/oma-yritys",
          text: "Oma yritys",
          className: "company-link-js",
          handleClick: toggleFunc
        });
      }
    }
  }, {
    key: "renderAuthLinks",
    value: function renderAuthLinks(toggleFunc) {
      if (this.props.user) {
        return _react2.default.createElement(
          "div",
          null,
          this.renderLicenseLink(toggleFunc),
          _react2.default.createElement(_MenuLink2.default, {
            link: "/omat-tietoni",
            text: "Profiilin asetukset",
            handleClick: toggleFunc
          }),
          _react2.default.createElement(_MenuLink2.default, {
            className: "logout-js",
            link: "/",
            text: "Kirjaudu ulos",
            handleClick: this.logout,
            noActive: true
          })
        );
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_MenuLink2.default, {
          className: "login-js",
          link: "/kirjaudu",
          text: "Kirjaudu sis\xE4\xE4n",
          handleClick: toggleFunc
        }),
        _react2.default.createElement(_MenuLink2.default, {
          className: "register-js",
          link: "/rekisteroidy",
          text: "Rekister\xF6idy",
          handleClick: toggleFunc
        })
      );
    }
  }, {
    key: "renderLicenseLink",
    value: function renderLicenseLink(toggleFunc) {
      if (!(0, _UserUtil.isPaidUser)(this.props.user)) {
        return _react2.default.createElement(_MenuLink2.default, {
          className: "license-js",
          link: "/maksullinen-profiili",
          text: "Maksullinen profiili",
          handleClick: toggleFunc
        });
      }
    }
  }]);
  return Menu;
}(_react.Component), _class.propTypes = {
  type: _react.PropTypes.oneOf(["desktop", "mobile"]).isRequired,
  open: _react.PropTypes.bool.isRequired,
  toggle: _react.PropTypes.func.isRequired,
  logout: _react.PropTypes.func.isRequired,
  user: _react.PropTypes.object,
  company: _react.PropTypes.object
}, _temp2);
exports.default = Menu;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/menu/Menu.js
 ** module id = 1159
 ** module chunks = 0
 **/